import endpoints from '../../config/endpoints';
import http from '../shared/http';
import intl from '../shared/intl';
import { formatEnumFormOptions } from '../shared/format';
import { handleActions } from 'redux-actions';
//import { LOCATION_CHANGE } from 'react-router-redux';
import { SubmissionError, reset, change } from 'redux-form';
import { getCurrencyIcon } from '../../../shared/js/get-currency-icon';
import { enum as payoutSystemStatuses } from '../../../../enums/payout-system-statuses';

import { actions as rootActions } from '../root';
import { actions as dashboardActions } from '../dashboard';

import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import isObject from 'lodash/isObject';
import mapValues from 'lodash/mapValues';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';

// actions types
const USER_FETCH_DATA_SUCCESS = 'profile/fetch-data-success';
const USER_FETCH_DATA_ERROR = 'profile/fetch-data-error';

const USER_CLEAR_DATA = 'profile/clear-data';
const USER_DELETE_AVATAR = 'profile/delete-avatar';

const TOGGLE_PROGRESS_BAR = 'profile/toggle-progress-bar';

const UPLOAD_SUCCESS = 'profile/upload-success';
const UPLOAD_ERROR = 'profile/upload-error';
const ADD_FILE_TO_UPLOAD = 'profile/add-file-to-upload';
const TOO_LARGE_FILE = 'profile/too-large-file';
const UPDATE_PROFILE_SUCCESS = 'profile/update-profile-success';
const UPDATE_PROFILE_ERROR = 'profile/update-profile-error';

const SHOW_ADD_PAYMENT_FORM = 'profile/show-add-payment';
const HIDE_ADD_PAYMENT_FORM = 'profile/hide-add-payment';
const UPDATE_ADD_PAYMENT_FIELDS = 'profile/update-add-payment';
const ADD_PAYMENT_SYSTEM_SUCCESS = 'profile/add-payment-system-success';
const ADD_PAYMENT_SYSTEM_ERROR = 'profile/add-payment-system-error';

const TWO_FACTOR_AUTHENTICATION_INIT_SUCCESS = 'profile/init-two-factor-authentication-success';
const TWO_FACTOR_AUTHENTICATION_INIT_ERROR = 'profile/init-two-factor-authentication-error';

const TWO_FACTOR_AUTHENTICATION_ACTIVATE_SUCCESS = 'profile/activate-two-factor-authentication-success';
const TWO_FACTOR_AUTHENTICATION_ACTIVATE_ERROR = 'profile/activate-two-factor-authentication-error';

const TWO_FACTOR_AUTHENTICATION_DEACTIVATE_SUCCESS = 'profile/deactivate-two-factor-authentication-success';
const TWO_FACTOR_AUTHENTICATION_DEACTIVATE_ERROR = 'profile/deactivate-two-factor-authentication-error';

const TWO_FACTOR_AUTHENTICATION_FINISH = 'profile/finish-two-factor-authentication';

const REFETCH_ALL_DATA = 'profile/refetch_all';

const TOGGLE_MODAL_TIMEZONE = 'profile/toggle-modal-timezone';

const CITIES_FETCH_DATA_SUCCESS = 'profile/cities-fetch-data-success';
const CITIES_FETCH_DATA_ERROR = 'profile/cities-fetch-data-error';

// initial state
const initialState = {
	data: null,
	profile: null,
	error: null,
	showModalTimezone: false,
	forms: {
		personalData: {
			avatar: null,
			name: '',
			promo_code: '',
			phone: '',
			email: '',
			skype: '',
			telegram: '',
			language: '',
			nickname: ''
		},
		changePassword: {
			old_password: '',
			new_password: '',
			new_password_confirmation: ''
		},
		notifications: {
			digest: [],
			new_offer: [],
			new_thread: [],
			new_thread_post: [],
			offer_change: [],
			payout_status_change: [],
			promo: [],
			system_news: []
		},
		paymentForm: {
			system: null
		},
		twoFactorAuthentication: {
			token: '',
			is_two_factor_authentication_enabled: false,
			step: 1,
			secret: '',
			otpauth_url: ''
		}
	},
	newAvatar: null,
	showProgressBar: false,
	showAddNewPaymentForm: false,
	newPaymentFormFields: [],
	selectedNewSystem: null,
	uploadError: false
};

const DEFAULT_YEAR_IF_NOT_FILLED = 1900;

// actions
export const actions = Object.assign({
	fetchData: () => {
		return dispatch => {
			const { MAIN, PAYOUT_SYSTEMS, NOTIFICATIONS, PREFERRED_GIFT } = endpoints.PROFILE;
			const request = http({
				url: [MAIN, PAYOUT_SYSTEMS, NOTIFICATIONS, PREFERRED_GIFT],
				method: 'get',
				actions: [USER_FETCH_DATA_SUCCESS, USER_FETCH_DATA_ERROR]
			});

			request(dispatch);
		};
	},

	clearData: () => ({
		type: USER_CLEAR_DATA
	}),

	deleteAvatar: () => ({
		type: USER_DELETE_AVATAR
	}),

	showAddPaymentForm: () => ({
		type: SHOW_ADD_PAYMENT_FORM
	}),

	hidePaymentForm: () => dispatch => {
		dispatch(reset('profilePaymentForm'));
		dispatch(change('profilePaymentForm', 'system', null));
		dispatch({ type: HIDE_ADD_PAYMENT_FORM });
	},

	updatePaymentsFields: data => (dispatch, getState) => {
		dispatch(reset('profilePaymentForm'));
		const system = find(getState().profile.data.payoutSystems, s => s.id == data.value);
		dispatch({
			type: UPDATE_ADD_PAYMENT_FIELDS,
			payload: omit(system, ['payout_setting_id', 'credentials'])
		});
	},

	addFileToUpload: (file, nextAction) => dispatch => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = function() {
			nextAction(file);
			dispatch({
				type: ADD_FILE_TO_UPLOAD,
				payload: {
					base64: reader.result,
					file: file
				}
			});
		};

		if (file && file.size > 5 * 1024 * 1024) {
			dispatch({
				type: TOO_LARGE_FILE
			});
			return;
		}
	},

	uploadAvatar: lang => (dispatch, getState) => {
		const data = new FormData();
		const file = getState().profile.newAvatar;
		data.append('avatar', file);

		const request = http({
			url: endpoints.PROFILE.AVATAR,
			method: 'put',
			actions: [UPLOAD_SUCCESS, UPLOAD_ERROR],
			data: data
		});

		request(dispatch).then(action => {
			dispatch(actions.toggleProgressBar());
			if (action.type === UPLOAD_SUCCESS) {
				dispatch(rootActions.fetchAppData(lang));
			}
		});
	},
	updatePassword: data => (dispatch, getState) => {
		const translator = intl(getState());

		if (data.new_password != data.new_password_confirmation) {
			throw new SubmissionError({
				['new_password']: translator('Пароли не совпадают'),
				['new_password_confirmation']: translator('Пароли не совпадают')
			});
		}

		const request = http({
			url: endpoints.PROFILE.PASSWORD,
			method: 'put',
			actions: [UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_ERROR],
			data
		});

		dispatch(actions.toggleProgressBar());

		return request(dispatch).then(action => {
			dispatch(actions.toggleProgressBar());

			if (action.type === UPDATE_PROFILE_ERROR && action.payload.response.status === 400) {
				submitErrorsHandler(action.payload.response.data, getState);
			}
		});
	},
	updateNotifications: data => (dispatch, getState) => {
		const state = getState();
		const newData = mapValues(data, (val, key) => {
			return Object.keys(data[key]).filter(it => {
				return find(state.app.lists['notification-transports'], { id: it }) && !!data[key][it];
			});
		});
		const request = http({
			url: endpoints.PROFILE.NOTIFICATIONS,
			method: 'put',
			actions: [UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_ERROR],
			data: newData
		});

		dispatch(actions.toggleProgressBar());
		return request(dispatch).then(action => {
			if (action.type === UPDATE_PROFILE_SUCCESS && !action.payload.data.errors) {
				dispatch(actions.fetchData());
			}

			if (action.type === UPDATE_PROFILE_ERROR && action.payload.response.status === 400) {
				dispatch(actions.toggleProgressBar());
				submitErrorsHandler(action.payload.response.data, getState);
			}
		});
	},
	updatePersonal: (data, initial) => (dispatch, getState) => {
		const avatar = getState().profile.newAvatar;
		if (avatar && avatar.size > 5 * 1024 * 1024) {
			dispatch({
				type: TOO_LARGE_FILE
			});
			return;
		}

		const fields = ['language', 'timezone', 'nickname'];
		if (!initial.skype && data.skype) {
			fields.push('skype');
		}
		if (!initial.telegram && data.telegram) {
			fields.push('telegram');
		}
		if (!initial.whatsapp && data.whatsapp) {
			fields.push('whatsapp');
		}
		if (!initial.phone && data.phone) {
			fields.push('phone');
		}
		if (!initial.promo_code && data.promo_code) {
			fields.push('promo_code');
		}
		if ((!initial.city || initial.can_change_city) && data.city) {
			fields.push('city_id');
			data.city_id = data.city ? data.city.value : null;
		}
		if (!initial.birthday && data.birthday_day && data.birthday_month ) {
			fields.push('birthday');
			data.birthday = `${data.birthday_year && data.birthday_year.value || DEFAULT_YEAR_IF_NOT_FILLED}` +
				`-${data.birthday_month.value}-${data.birthday_day.value}`;
		}

		data = pick(data, fields);
		data.language = data.language.value ? data.language.value : data.language;
		data.timezone = data.timezone.value ? data.timezone.value : data.timezone;
		data.nickname = data.nickname && data.nickname.trim().length ? data.nickname.trim() : null;

		const request = http({
			url: endpoints.PROFILE.MAIN,
			method: 'put',
			actions: [UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_ERROR],
			data
		});

		dispatch(actions.toggleProgressBar());

		return request(dispatch).then(action => {
			if (action.type === UPDATE_PROFILE_SUCCESS && !action.payload.data.errors) {
				if (isObject(avatar)) {
					dispatch(actions.uploadAvatar(data.language));
				} else {
					dispatch(rootActions.fetchAppData(data.language)).then(action => {
						dispatch(dashboardActions.fetchData());
						dispatch({ type: REFETCH_ALL_DATA });
					});
				}
			}

			if (action.type === UPDATE_PROFILE_ERROR && action.payload.response.status === 400) {
				dispatch(actions.toggleProgressBar());
				submitErrorsHandler(action.payload.response.data, getState);
				dispatch(reset('profilePersonalDataForm'));
			}
		});
	},

	createPayoutSetting: (data) => (dispatch, getState) => {
		const { system, ...credentials } = data;

		const request = http({
			url: endpoints.PROFILE.PAYOUT_SETTINGS,
			method: 'post',
			actions: [ADD_PAYMENT_SYSTEM_SUCCESS, UPDATE_PROFILE_ERROR],
			data: {
				payout_system_id: system.value,
				credentials
			},
			addToResponse: data
		});

		dispatch(actions.toggleProgressBar());

		return request(dispatch).then(action => {
			if (action.type === ADD_PAYMENT_SYSTEM_SUCCESS) {
				dispatch(reset('profilePaymentForm'));
				dispatch({ type: HIDE_ADD_PAYMENT_FORM });
				dispatch(actions.fetchData());
			}

			if (action.type === UPDATE_PROFILE_ERROR && action.payload.response.status === 400) {
				dispatch(actions.toggleProgressBar());
				dispatch({ type: ADD_PAYMENT_SYSTEM_ERROR, payload: data });

				const lang = getState().app.userData.general.language;
				const validationsErrors = {};
				forEach(action.payload.response.data, value => {
					let key = value.dataPath.slice(1);
					if (isEmpty(value.dataPath)) {
						let rightIndex = 0;
						if (lang == 'de') {
							rightIndex = 1;
						}
						const splitted = value.message.split(' ');
						const index = splitted.length - 1 - rightIndex;
						key = splitted[index];
						value.message = value.message.split(' ');
						value.message.pop();
						if (lang == 'de') {
							value.message.pop();
						}
						value.message = value.message.join(' ');
					}
					validationsErrors[key] = value.message;
				});
				throw new SubmissionError(validationsErrors);
			}
		});
	},

	toggleHiddenFromNavbarBalance: data => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.PROFILE.BALANCES}/hidden-from-navbar`,
			method: 'put',
			actions: [UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_ERROR],
			data: data
		});
		return request(dispatch)
			.then(action => {
				if (action.type === UPDATE_PROFILE_SUCCESS && !action.payload.data.errors) {
					dispatch(rootActions.fetchAppData()).then(action => {
						dispatch(actions.fetchData());
					});
				}
			});
	},

	updateBalances: data => (dispatch, getState) => {
		const request = http({
			url: endpoints.PROFILE.BALANCES,
			method: 'post',
			actions: [UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_ERROR],
			data
		});

		dispatch(actions.toggleProgressBar());

		return request(dispatch).then(action => {
			dispatch(actions.toggleProgressBar());

			if (action.type === UPDATE_PROFILE_SUCCESS && !action.payload.data.errors) {
				dispatch(rootActions.fetchAppData()).then(action => {
					dispatch(actions.fetchData());
				});
			}

			if (action.type === UPDATE_PROFILE_ERROR && action.payload.response.status === 400) {
				submitErrorsHandler(action.payload.response.data, getState);
			}
		});
	},

	toggleProgressBar: () => ({
		type: TOGGLE_PROGRESS_BAR
	}),

	toggleModalTimezone: () => ({
		type: TOGGLE_MODAL_TIMEZONE
	}),

	chooseTimezoneFromMap: timeZone => dispatch => {
		dispatch(change('profilePersonalDataForm', 'timezone', timeZone));
		dispatch(actions.toggleModalTimezone());
	},

	initTwoFactorAuthentication: () => (dispatch, getState) => {
		const request = http({
			url: endpoints.PROFILE.TWO_FACTOR_AUTHENTICATION_INIT,
			method: 'post',
			actions: [TWO_FACTOR_AUTHENTICATION_INIT_SUCCESS, TWO_FACTOR_AUTHENTICATION_INIT_ERROR]
		});
		return request(dispatch);
	},

	activateTwoFactorAuthentication: data => (dispatch, getState) => {
		const request = http({
			url: endpoints.PROFILE.TWO_FACTOR_AUTHENTICATION_ACTIVATE,
			method: 'post',
			actions: [TWO_FACTOR_AUTHENTICATION_ACTIVATE_SUCCESS, TWO_FACTOR_AUTHENTICATION_ACTIVATE_ERROR],
			data
		});
		const translator = intl(getState());

		return request(dispatch).then(action => {
			if (action.type === TWO_FACTOR_AUTHENTICATION_ACTIVATE_ERROR && action.payload.response.status === 400) {
				const validationsErrors = {};
				const responseErrors = action.payload.response.data.errors;

				forEach(responseErrors, value => {
					const key = value.dataPath.slice(1);
					/* ["Token is not valid"] */
					validationsErrors[key] = translator(value.message);
				});
				throw new SubmissionError(validationsErrors);
			}
		});
	},

	deactivateTwoFactorAuthentication: () => (dispatch, getState) => {
		const translator = intl(getState());
		if (window.confirm(translator('Вы действительно хотите отключить двухфактурную аутентификацию?'))) {
			const request = http({
				url: endpoints.PROFILE.TWO_FACTOR_AUTHENTICATION_DEACTIVATE,
				method: 'post',
				actions: [TWO_FACTOR_AUTHENTICATION_DEACTIVATE_SUCCESS, TWO_FACTOR_AUTHENTICATION_DEACTIVATE_ERROR]
			});
			return request(dispatch);
		}
	},

	finishTwoFactorAuthentication: () => ({
		type: TWO_FACTOR_AUTHENTICATION_FINISH
	}),

	lookupCities: (search, callback) => (dispatch) => {
		const request = http({
			url: endpoints.LOOKUPS.CITIES,
			method: 'get',
			data: { query: search },
			actions: [CITIES_FETCH_DATA_SUCCESS, CITIES_FETCH_DATA_ERROR]
		});

		request(dispatch).then((action) => {
			if (action.type === CITIES_FETCH_DATA_SUCCESS) {
				callback(null, {
					options: action.payload.data.map((city) => ({
						value: city.id,
						label: city.text
					}))
				});
			} else {
				callback(null);
			}
		});
	}
});

// reducers
const reducers = Object.assign({
	[USER_FETCH_DATA_SUCCESS]: (state, action) => {
		const [profile, payoutSystems, notifications, prefferedGift] = action.payload;
		return {
			...state,
			showProgressBar: false,
			data: {
				profile: profile.data,
				payoutSystems: payoutSystems.data,
				prefferedGift: prefferedGift.data,
				notifications: notifications.data
			}
		};
	},
	[USER_FETCH_DATA_ERROR]: (state, action) => {
		return { ...state, errors: true, showProgressBar: false };
	},
	[USER_CLEAR_DATA]: (state, action) => {
		return initialState;
	},
	[REFETCH_ALL_DATA]: (state, action) => {
		return initialState;
	},
	[USER_DELETE_AVATAR]: (state, action) => {
		return {
			...state,
			data: {
				...state.data,
				profile: {
					...state.data.profile,
					avatar: null
				}
			},
			newAvatar: null,
			uploadError: false
		};
	},
	[UPLOAD_SUCCESS]: (state, action) => {
		return {
			...state,
			newAvatar: null,
			uploadError: false
		};
	},
	[ADD_FILE_TO_UPLOAD]: (state, action) => {
		return {
			...state,
			data: {
				...state.data,
				profile: {
					...state.data.profile,
					avatar: action.payload.base64
				}
			},
			newAvatar: action.payload.file,
			uploadError: false
		};
	},
	[TOGGLE_PROGRESS_BAR]: (state, action) => {
		return { ...state, showProgressBar: !state.showProgressBar };
	},
	[SHOW_ADD_PAYMENT_FORM]: (state, action) => {
		return { ...state, showAddNewPaymentForm: true };
	},
	[HIDE_ADD_PAYMENT_FORM]: (state, action) => {
		return { ...state, showAddNewPaymentForm: false, newPaymentFormFields: [], selectedNewSystem: null };
	},
	[UPDATE_ADD_PAYMENT_FIELDS]: (state, action) => {
		return { ...state, newPaymentFormFields: action.payload.fields, selectedNewSystem: action.payload };
	},
	[TOO_LARGE_FILE]: (state, action) => {
		return {
			...state,
			newAvatar: null,
			uploadError: true
		};
	},
	[ADD_PAYMENT_SYSTEM_SUCCESS]: (state, action) => {
		return {
			...state,
			forms: {
				...state.forms,
				paymentForm: {
					system: null
				}
			}
		};
	},
	[ADD_PAYMENT_SYSTEM_ERROR]: (state, action) => {
		return {
			...state,
			forms: {
				...state.forms,
				paymentForm: action.payload
			}
		};
	},
	[TWO_FACTOR_AUTHENTICATION_INIT_SUCCESS]: (state, action) => {
		return {
			...state,
			forms: {
				...state.forms,
				twoFactorAuthentication: {
					secret: action.payload.data.secret,
					otpauth_url: action.payload.data.otpauth_url,
					step: 2
				}
			}
		};
	},

	[TWO_FACTOR_AUTHENTICATION_ACTIVATE_SUCCESS]: (state, action) => {
		return {
			...state,
			forms: {
				...state.forms,
				twoFactorAuthentication: {
					step: 3,
					secret: null,
					otpauth_url: null,
					two_factor_recovery_codes: action.payload.data.two_factor_recovery_codes
				}
			},
			data: {
				...state.data,
				profile: {
					...state.data.profile,
					is_two_factor_authentication_enabled: true
				}
			}
		};
	},

	[TWO_FACTOR_AUTHENTICATION_FINISH]: (state) => {
		return {
			...state,
			forms: {
				...state.forms,
				twoFactorAuthentication: {
					step: 1
				}
			},
			data: {
				...state.data,
				profile: {
					...state.data.profile,
					two_factor_recovery_codes: null
				}
			}
		};
	},

	[TWO_FACTOR_AUTHENTICATION_DEACTIVATE_SUCCESS]: (state) => {
		return {
			...state,
			forms: {
				...state.forms,
				twoFactorAuthentication: {
					step: 1
				}
			},
			data: {
				...state.data,
				profile: {
					...state.data.profile,
					is_two_factor_authentication_enabled: false
				}
			}
		};
	},

	[TOGGLE_MODAL_TIMEZONE]: state => ({...state, showModalTimezone: !state.showModalTimezone}),

	[CITIES_FETCH_DATA_SUCCESS]: state => state,
	[CITIES_FETCH_DATA_ERROR]: state => ({ ...state, errors: true, showProgressBar: false })
});

export default handleActions(reducers, cloneDeep(initialState));

function submitErrorsHandler(responseErrors, getState) {
	const validationsErrors = {};
	const intl = getState && selectors.getIntl(getState());
	forEach(responseErrors, value => {
		const key = value.dataPath.slice(1);
		validationsErrors[key] = intl && intl(value.message);
	});
	throw new SubmissionError(validationsErrors);
}

// selectors
export const selectors = {
	getData: state => state.profile.data,
	getPersonalDataForm: state => {
		if (state.profile.data && state.profile.data.profile) {
			let result = {
				initialValues: {
					...state.profile.data.profile
				},
				uploadError: state.profile.uploadError
			};

			const city = state.profile.data.profile.city;

			if (city) {
				result = {
					...result,
					initialValues: {
						...result.initialValues,
						city: {
							value: city.id,
							label: city.text
						}
					}
				};
			}

			let dates = state.profile.data.profile.birthday && state.profile.data.profile.birthday.split('-');
			if (dates && dates.length) {
				const intl = selectors.getIntl(state);
				const monthOptions = [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'August',
					'September',
					'October',
					'November',
					'December'
				];

				result = {
					...result,
					initialValues: {
						...result.initialValues,
						birthday_day: { value: dates[2], label: dates[2] },
						birthday_month: { value: dates[1], label: intl(monthOptions[parseInt(dates[1]) - 1]) },
						birthday_year: Number(dates[0]) > DEFAULT_YEAR_IF_NOT_FILLED
							? { value: dates[0], label: dates[0] }
							: { value: null, label: null },
						additional_birthdays: result.initialValues.additional_birthdays &&
							result.initialValues.additional_birthdays
								.map(abd => abd && abd.split('-'))
								.map(additionalDate => ({
									birthday_day: additionalDate[2],
									birthday_year:
										Number(additionalDate[0]) > DEFAULT_YEAR_IF_NOT_FILLED ? additionalDate[0] : null,
									birthday_month: intl(monthOptions[parseInt(additionalDate[1]) - 1])
								}))
					}
				};
			}
			return result;
		}
	},
	getLanguages: state => state.app.lists.languages,
	getTimezones: state => formatEnumFormOptions(state.app.lists.timezones),
	getPayoutCredentialFields: state => formatEnumFormOptions(state.app.lists['payout-credential-fields']),
	getBalances: state => ({
		connected: state.app.userData.balances,
		available: formatEnumFormOptions(state.app.lists['available-currencies'])
	}),
	getNotifiTypes: state => state.app.lists['notification-transports'],
	getTwoFactorAuthenticationFormData: state => state.profile.forms.twoFactorAuthentication,
	getPasswordFormData: state => ({
		initialValues: state.profile.forms.changePassword
	}),
	getPaymentsData: state => {
		const data = state.profile.data;

		if (!data) {
			return null;
		}

		const connectedSystems = data.payoutSystems.filter((s) => !isEmpty(s.credentials));

		const systemsOptions = uniqBy(data.payoutSystems, 'id')
			.filter((s) => s.status === payoutSystemStatuses.active)
			.map((s) => ({
				label: `${s.title} (${getCurrencyIcon(s.currency)})`,
				value: s.id
			}));

		return {
			connectedSystems,
			systemsOptions,
			showForm: state.profile.showAddNewPaymentForm,
			formFields: state.profile.newPaymentFormFields,
			selectedNewSystem: state.profile.selectedNewSystem,
			initialValues: state.profile.forms.paymentForm
		};
	},
	getNotificationsDataForm: state => {
		if (!state.profile.data) {
			return null;
		}
		const data = state.profile.data.notifications;
		const notifyKeys = Object.keys(state.profile.forms.notifications);
		const initialValues = {};
		forEach(notifyKeys, key => {
			Object.assign(initialValues, {
				[key]: {
					email: data[key].includes('email') || '',
					sms: data[key].includes('sms') || '',
					push: data[key].includes('push') || ''
				}
			});
		});
		return { initialValues };
	},
	getProgressBar: state => state.profile.showProgressBar,
	getShowModalTimezone: state => state.profile.showModalTimezone,
	getIntl: intl,
	getError: state => state.profile.error
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/index.js